import starterGuideData from "./Guides/StarterGuide";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const StarterGuide = () => {
  return <GuideRenderer url="beginner" guideData={starterGuideData} />;
};

export default StarterGuide;
